export default __webpack_public_path__ + "static/Futura-Bold-bc367938448e13a99de24adc265a8894.woff";